// extracted by mini-css-extract-plugin
export default {"staffHeaderRow":"TeamStaff_staffHeaderRow__ZRu58"};